import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export const KpiTypeTranslationMap = {
    [KpiType.OPPORTUNITY_ALIGNMENT]:
        TranslationKeyMap._797_OPPORTUNITY_ALIGNMENT,
    [KpiType.MANAGEMENT_IMPROVEMENT_INDEX]: TranslationKeyMap._798_MI2,
    [KpiType.FRONT_LINE_OA]: TranslationKeyMap._9845_FRONT_LINE_OA,
    [KpiType.WINNING_PERCENTAGE]: TranslationKeyMap._10094_WINNING__,
    [KpiType.FL_MANAGEMENT_IMPROVEMENT_INDEX]:
        TranslationKeyMap._11118_FRONT_LINE_MI2,
    [KpiType.FL_WINNING_PERCENTAGE]:
        TranslationKeyMap._11080_FRONT_LINE_WINNING__,
};
